import React from 'react'
import { today } from './inventoryData';
import { Field, PanelTitle } from './InventoryShared';

function StockTransferPage({ items }) {
    return (
        <section className='inventory-panel inventory-form-page'>
            <PanelTitle title='Stock Transfer' />
            <div className='inventory-form-grid two-column'>
                <Field label='From Outlet' type='select' options={['Main Branch', 'Central Store', 'Kitchen']} />
                <Field label='To Outlet' type='select' options={['Outlet 2', 'Bar Counter', 'Kitchen']} />
                <Field label='Item Name' type='select' options={items.map(item => item.name)} />
                <Field label='Quantity' type='number' placeholder='5' />
                <Field label='Transfer Date' type='date' defaultValue={today} />
            </div>
            <div className='inventory-actions sticky'><button>Confirm Transfer</button></div>
        </section>
    );
}

export default StockTransferPage
